import { polyfill } from 'es6-promise'; polyfill();
import WebViewer from './WebViewer';

export default class RfaViewer {

  constructor() {

  }

  Initialize = (canvasWrapper, scene) => {
    canvasWrapper.Viewer = canvasWrapper.Viewer || new WebViewer();
    canvasWrapper.Viewer.init(canvasWrapper, function () {
      console.log("Finished initializing the RFA Viewer");
    });

    canvasWrapper.Viewer.loadScene(scene, function () {
      if (scene && scene.object)
        console.log("Loaded the following scene: " + scene.object.name);
    });
  }

  IsReady = (canvasWrapper) => {
    return canvasWrapper && canvasWrapper.getElementsByTagName("canvas").length;
  }

  LoadScene = (canvasWrapper, scene) => {
    canvasWrapper.Viewer = canvasWrapper.Viewer || new WebViewer();

    if (!this.IsReady(canvasWrapper)) {
      console.log("RFA Viewer is not ready, re-initializing it.");
      canvasWrapper.Viewer.init(canvasWrapper, function () { this.loadScene(canvasWrapper, scene); });
      return;
    }

    canvasWrapper.Viewer.loadScene(scene, function () {
      console.log("A new scene has been just loaded into RFA Viewer");
    });
  }
}


